import { render, staticRenderFns } from "./u-file-input-filled-tile.vue?vue&type=template&id=6ff6c150&scoped=true"
import script from "./u-file-input-filled-tile.vue?vue&type=script&lang=js"
export * from "./u-file-input-filled-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6c150",
  null
  
)

export default component.exports